import React from 'react';
import dcgLogo from '../../../assets/img/brand/dcg_logo_header.png';
import Level3ConfirmationPageContent from '../PageContent/Level3ConfirmationPageContent';
import { SectionDivider, PageTitle, HeaderAndBodyLayout } from '../../../utilities/dcgAutomationPageCommonImports';

const Level3Confirmation = () => {
    return (
        <HeaderAndBodyLayout headerLogo={dcgLogo} containerSize="sm">
            <PageTitle
                heading="Please confirm you want to choose Level 3 permissions"
            />
            <SectionDivider width="70%" />
            <Level3ConfirmationPageContent />
        </HeaderAndBodyLayout>
    );
};

export default Level3Confirmation;